import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "result-view",
  "data-qe-id": "results"
}

import { computed } from 'vue'
import events from '@gd/event-bus'
import { useStore } from '@/store'
import MResult from '@/modules/MResult.vue'
import CCustomerService from '@/components/CCustomerService.vue'
import CTournamentHeader from '@/components/CTournamentHeader.vue'
import { getSubTopic, CsFormPreselections } from '@/lib/customerService'
import CNavigation from '@/components/CNavigation.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ResultView',
  props: {
    competitionId: {}
  },
  setup(__props: any) {

const props = __props
const store = useStore()

const zoneId = computed(() => {
  return store.getters['results/zoneId']
})

function onCustomer() {
  events.$emit('cs-form', {
    topic: 'duelError',
    subTopic: getSubTopic(zoneId.value),
    competitionId: props.competitionId,
  } as CsFormPreselections)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_t_container = _resolveComponent("t-container")!
  const _component_t_content = _resolveComponent("t-content")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_t_content, { main: "" }, {
      default: _withCtx(() => [
        _createVNode(CTournamentHeader, {
          zone: zoneId.value,
          language: _ctx.$i18n.locale
        }, null, 8, ["zone", "language"]),
        _createVNode(CNavigation, null, {
          default: _withCtx(() => [
            (zoneId.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: { path: `/tournaments/${zoneId.value}` }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('resultView.buttons.back')), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_t_container, null, {
          default: _withCtx(() => [
            _createVNode(MResult, { "competition-id": _ctx.competitionId }, null, 8, ["competition-id"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_t_content, null, {
      default: _withCtx(() => [
        _createVNode(_component_t_container, null, {
          default: _withCtx(() => [
            _createVNode(CCustomerService, {
              onCustomer: onCustomer,
              text: _ctx.$t('resultView.customerService.headline', { competitionId: _ctx.competitionId })
            }, null, 8, ["text"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})